import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { SPACE_SIZES } from '../../../constants/spaces.js';
import { Space } from '../../Space/src/Space.js';
import modules_6b210db9 from '../styles/Menu.module.less.js';

/**
 * @description Menu Item Group component.
 *
 * @component
 * @example
 * ```jsx
 * <Menu.ItemGroup title="hint">
 *   <Menu.Item>1 год</Menu.Item>
 * </Menu.Item>
 * ```
 */
const MenuItemGroup = React.forwardRef((props, ref) => {
    const { label, className, children, ...restProps } = props;
    const cx = useStyles(modules_6b210db9);
    const classNames = cx(className, 'item-group');
    return (React.createElement(Space, { ref: ref, direction: "vertical", className: classNames, ...restProps },
        React.createElement(Space, { align: "center", size: SPACE_SIZES.S4, className: cx('item-base', 'label') }, label),
        children));
});
MenuItemGroup.defaultProps = {};
MenuItemGroup.displayName = 'MenuItemGroup';

export { MenuItemGroup };
//# sourceMappingURL=MenuItemGroup.js.map
